import { Injectable } from '@angular/core';
import { DataService } from "../../../../shared/session/index";
import { SessionInfo } from "../../../../shared/session/SessionInfo";
import { Rol } from './../shared/rol.model';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class RolService {

  constructor(private dataService: DataService, private sessionInfo: SessionInfo) { }

  insertarRolUrl: string = 'Role/Insertar';
  actualizarRolUrl: string = 'Role/Actualizar';
  obtenerRolUrl: string = 'Role/Obtener';
  listarrolUrl: string = 'Role/Listar';
  listarPorrolPorUrl: string = 'Role/ListarPor';
  listarAplicacionesAllUrl: string = 'aplicacion/listar';
  listarRolAccessUrl: string = 'Role/listarAccess';
  listarRolPorAplicacionUrl: string = 'Role/listarByAplicacion';

  listarAplicaciones() {
    this.dataService.set(this.listarAplicacionesAllUrl);
    return this.dataService.execGetJson();
  }

  listarPorRol(filtro: string): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", filtro);
    this.dataService.set(this.listarPorrolPorUrl);
    return this.dataService.execGetJson(parameters);
  }

  // TODO: NO SE RELACIONA CON OTRAS FUNCIONALIDADES
  listarRolPorAplicacion(aplicacionID: number, filtro: string, pageIndex: number, pageSize: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pAplicacionID", String(aplicacionID));
    parameters = parameters.append("pFiltro", String(filtro));
    parameters = parameters.append("pOfficeID", String(this.sessionInfo.getOfficeID()));
    this.dataService.set(this.listarRolPorAplicacionUrl);
    return this.dataService.execGetJson(parameters);
  }

  // TODO: NO SE RELACIONA CON OTRAS FUNCIONALIDADES
  listarRolAccess(officeID: number, aplicacionID: number, filtro: string, pageIndex: number, pageSize: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pOfficeID", String(officeID));
    parameters = parameters.append("pAplicacionID", String(aplicacionID));
    parameters = parameters.append("pFiltro", String(filtro));
    this.dataService.set(this.listarRolAccessUrl);
    return this.dataService.execGetJson(parameters);
  }

  listarRol(filtro: string, pageIndex: number, pageSize: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pFiltro", String(filtro));
    this.dataService.set(this.listarPorrolPorUrl);
    return this.dataService.execGetJson(parameters);
  }

  obtenerRol(roleID: number): any {
    let parameters = new HttpParams();
    parameters = parameters.append("pKey", String(roleID));

    this.dataService.set(this.obtenerRolUrl);
    return this.dataService.execGetJson(parameters);
  }

  insertarRol(rol: Rol): any {
    let parameters: string;
    parameters = JSON.stringify({
      Name: rol.Name,
      shortName: rol.shortName,
      description: rol.Description,
      UserCreation: this.sessionInfo.getCodUsuario(),
    });
    this.dataService.set(this.insertarRolUrl);
    return this.dataService.execPostJson(parameters);
  }

  actualizarRol(rol: Rol): any {
    let parameters: string;
    parameters = JSON.stringify({
      ID: rol.ID,
      Name: rol.Name,
      shortName: rol.shortName,
      description: rol.Description,
      Status: rol.Status,
      UserLastUpdate: this.sessionInfo.getCodUsuario(),
    });
    this.dataService.set(this.actualizarRolUrl);
    return this.dataService.execPostJson(parameters);
  }
}